import {
  faAddressCard,
  faReceipt,
  faGift,
  faQuestionCircle,
  faAd,
  faRssSquare,
  faCertificate,
  faDollarSign,
  faTicketAlt,
  faBuilding,
  faHome,
  faSuperscript,
  faCalendarAlt,
  faBell,
  faUser,
  faInbox,
  faParking,
  faCalendarCheck,
  faPlus,
  faRss,
  faUserCircle,
  faTable,
  faCarRear,
  faBolt,
  faIdBadge,
  faHouseUser,
  faSquareParking,
  faBullseye,
  faCity,
  faAdd,
  faImage,
  faImages,
  faStamp,
  faGem,
  faRectangleList,
} from "@fortawesome/free-solid-svg-icons";

let options = [
  {
    key: "member",
    label: "sidebar.member",
    leftIcon: faAddressCard,
    permissionSets: [[{ section: "MEMBER", function: "LIST" }]],
  },
  {
    key: "sinoClubMember",
    label: "sidebar.sinoclubmember",
    leftIcon: faIdBadge,
    permissionSets: [[{ section: "SINO_CLUB", function: "LIST_MEMBERS" }]],
  },
  {
    key: "sinoClubMembershipUpgrade",
    label: "sidebar.sinoclubmemberupgrade",
    leftIcon: faHouseUser,
    permissionSets: [
      [{ section: "SINO_CLUB", function: "LIST_MEMBERSHIP_UPGRADE" }],
    ],
  },
  {
    key: "sinoClubPMemberReferralCode",
    label: "sidebar.sinoClubPMemberReferralCode",
    leftIcon: faAdd,
    permissionSets: [
      [{ section: "SINO_CLUB_PRIVILEGE_MEMBER_REFERRAL", function: "LIST" }],
    ],
  },
  {
    key: "estate",
    label: "sidebar.estate",
    leftIcon: faCity,
    permissionSets: [[{ section: "ESTATE", function: "LIST" }]],
  },
  {
    key: "sinoParking",
    label: "sidebar.sinoclubparking",
    leftIcon: faSquareParking,
    permissionSets: [[{ section: "SINO_PARKING", function: "LIST" }]],
  },
  {
    key: "spendingTransaction",
    label: "sidebar.spendingTransaction",
    leftIcon: faReceipt,
    permissionSets: [[{ section: "SPENDING_TRANSACTION", function: "LIST" }]],
  },
  {
    key: "campaignCode",
    label: "sidebar.campaignCode",
    leftIcon: faRectangleList,
    permissionSets: [[{ section: "CAMPAIGN_CODE", function: "LIST" }]],
  },
  {
    key: "gift",
    label: "sidebar.gift",
    leftIcon: faGift,
    permissionSets: [[{ section: "GIFT", function: "LIST" }]],
  },
  {
    key: "onlineEnquiry",
    label: "sidebar.onlineEnquiry",
    leftIcon: faQuestionCircle,
    permissionSets: [],
  },
  {
    key: "mall",
    label: "sidebar.mall",
    leftIcon: faBuilding,
    permissionSets: [[{ section: "MALL", function: "LIST" }]],
  },
  {
    key: "shop",
    label: "sidebar.shop",
    leftIcon: faHome,
    permissionSets: [[{ section: "SHOP", function: "LIST" }]],
  },
  {
    key: "sdollar",
    label: "sidebar.sdollar",
    leftIcon: faDollarSign,
    permissionSets: [
      [{ section: "S_COUPON_AND_S_DOLLAR_SHOPS", function: "LIST" }],
    ],
  },
  {
    key: "coupon",
    label: "sidebar.sCoupon",
    leftIcon: faTicketAlt,
    permissionSets: [[{ section: "S_COUPON", function: "LIST" }]],
  },
  {
    key: "Banner",
    label: "sidebar.banner",
    leftIcon: faImage,
    permissionSets: [[{ section: "BANNER", function: "LIST" }]],
  },
  {
    key: "dynamicBannerList",
    label: "sidebar.bannerList",
    leftIcon: faImages,
    permissionSets: [[{ section: "BANNER_LIST", function: "LIST" }]],
  },
  {
    key: "crazyAd",
    label: "sidebar.crazyAd",
    leftIcon: faAd,
    permissionSets: [[{ section: "CRAZY_AD", function: "LIST" }]],
  },
  {
    key: "mission",
    label: "sidebar.mission",
    leftIcon: faBullseye,
    permissionSets: [[{ section: "ACTIVITY", function: "LIST" }]],
  },
  {
    key: "stamp",
    label: "sidebar.stamp",
    leftIcon: faStamp,
    permissionSets: [[{ section: "ACTIVITY", function: "LIST" }]],
  },
  {
    key: "unpublishedPrivilege",
    label: "sidebar.unpublishedPrivilege",
    leftIcon: faGem,
    permissionSets: [[{ section: "EXCLUSIVE_REWARD", function: "LIST" }]],
  },
  {
    key: "memberTags",
    label: "sidebar.memberTags",
    leftIcon: faCertificate,
    permissionSets: [[{ section: "MEMBER_TAG", function: "LIST" }]],
  },
  {
    key: "spendingPointBonusRule",
    label: "sidebar.spendingPointBonusRule",
    leftIcon: faSuperscript,
    permissionSets: [[{ section: "BONUS_RULE", function: "LIST" }]],
  },
  {
    key: "contactlessParking",
    label: "sidebar.contactlessParking",
    leftIcon: faCarRear,
    permissionSets: [[{ section: "CONTACTLESS_PARKING", function: "LIST" }]],
  },
  {
    key: "parkingRecord",
    label: "sidebar.createParkingRecords",
    leftIcon: faParking,
    permissionSets: [[{ section: "PARKING_RECORDS", function: "LIST" }]],
  },
  {
    key: "checkInEvent",
    label: "sidebar.checkInEvent",
    leftIcon: faCalendarCheck,
    permissionSets: [[{ section: "CHECK_IN_EVENT", function: "LIST" }]],
  },
  {
    key: "user",
    label: "sidebar.user",
    leftIcon: faUser,
    permissionSets: [[{ section: "USER", function: "LIST" }]],
  },
  {
    key: "userNotification",
    label: "sidebar.userPushRecord",
    leftIcon: faBell,
    permissionSets: [[{ section: "USER_PUSH_RECORD", function: "LIST" }]],
  },
  {
    key: "userInboxMessage",
    label: "sidebar.userInboxMessage",
    leftIcon: faInbox,
    permissionSets: [[{ section: "USER_INBOX_MESSAGE", function: "LIST" }]],
  },
  {
    key: "merchantNotification",
    label: "sidebar.merchantPushRecord",
    leftIcon: faBell,
    permissionSets: [[{ section: "MERCHANT_PUSH_RECORD", function: "LIST" }]],
  },
  {
    key: "merchantInboxMessage",
    label: "sidebar.merchantInboxMessage",
    leftIcon: faInbox,
    permissionSets: [[{ section: "MERCHANT_INBOX_MESSAGE", function: "LIST" }]],
  },
  {
    key: "merchantCustomReferralPoint",
    label: "sidebar.merchantCustomReferralPoint",
    leftIcon: faPlus,
    permissionSets: [
      [{ section: "CUSTOM_REFERRAL_BONUS_POINT", function: "LIST" }],
    ],
  },
  {
    key: "thirdPartyIntegrator",
    label: "sidebar.thirdPartyIntegrator",
    leftIcon: faUserCircle,
    permissionSets: [[{ section: "THIRD_PARTY_INTEGRATOR", function: "LIST" }]],
  },
];
if (process.env.REACT_APP_SHOW_MALL_SECTION === "false") {
  options = options.filter((value) => value.key !== "mall");
}

export default options;
